module.exports = __webpack_public_path__ + "static/media/icon_star_yellow.61e45ec6.svg";